import * as actionTypes from './actionTypes';
import { serviceGetUser, serviceRefreshToken } from './service';
import { openModal } from '@app/src/commons/modal/state/modals/actions';

const fetchfilterValuesRequest = () => ({
  type: actionTypes.FETCH_FILTER_VALUES_REQUEST
});

const fetchfilterValuesFailure = (errorMessage: string, errorRol?: boolean) => ({
  type: actionTypes.FETCH_FILTER_VALUES_FAILURE,
  errorMessage,
  errorRol
});

const fetchfilterValuesSuccess = (data: object) => ({
  type: actionTypes.FETCH_FILTER_VALUES_SUCCESS,
  data
});

const fetchIdUser = (idUser: number) => ({
  type: actionTypes.FETCH_GET_IDUSER,
  idUser
})

const fetchGetRefreshToken = () => ({
  type: actionTypes.FETCH_REFRESHTOKEN_REQUEST
});

export const fetchUserValues = (): Function => {
  return async (dispatch, getState) => {
    const state = getState();
    const getidUser = state.filterEditUser.idUser;
    const idUser = getidUser.toString();
    dispatch(fetchfilterValuesRequest());
    try {
      const data = await serviceGetUser.getData(idUser);
      dispatch(fetchfilterValuesSuccess(data));
    } catch (error) {
      if (error.code === 143) {
        dispatch(fetchRefreshToken(idUser));
        return;
      }
      if (error.code === 132) {
        dispatch(fetchfilterValuesFailure('Error de validación de rol. Vuelva a iniciar sesión.', true));
        dispatch(openModal('CLOSE_SESSION_MODAL'));
        return;
      }
      dispatch(fetchfilterValuesFailure(error.message));
    }
  };
};

export const getIdUser = (idUser: number): Function => {
  return dispatch => {
    dispatch(fetchIdUser(idUser));
  }
}

const fetchRefreshToken = (idUser) => {
  return async dispatch => {
    dispatch(fetchGetRefreshToken());
    try {
      const refreshToken = localStorage.getItem('refreshtoken');
      const { data } = await serviceRefreshToken.getData(refreshToken);
      const value = await serviceGetUser.getData(idUser, data.accessToken);
      dispatch(fetchfilterValuesSuccess(value));
    } catch (error) {
      dispatch(fetchfilterValuesFailure(error.message));
    }
  }
}
